import moment from 'moment-timezone';

$(function(){

    const myProject = require('./_data/myProject');
    const myLinks = require('./_data/links');
    const envSettings = myProject[myProject.environment];
    const apiServer = envSettings.apiServer;
    const language = $('html')[0].lang;
    const timeZoneName = moment.tz.guess();
    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });
    const Uris = {
        jsonOfferRequestsAdd : apiServer + "/json/offerrequests/add"
    }


    function updateOfferRequest(){
        
        var offerRequest = {};

        let firstName = $("#firstNameInput").val();
        let lastName = $("#lastNameInput").val();
        let phone = $("#phoneInput").val();
        let email = $("#emailInput").val();
        let address = $("#addressInput").val();
        let zip = $("#zipInput").val();
        let city = $("#cityInput").val();
        let province = $("#provinceSelect").val();
        let buildingType = $("#buildingTypeSelect").val();
        let buildingTypeOther = $("#buildingTypeOtherInput").val();
        let area = $("#areaInput").val();
        let constructionYear = $("#constructionYearInput").val();
        let additionalInfo = $("#additionalInfoInput").val();


        offerRequest.firstName = firstName;
        offerRequest.lastName = lastName;
        offerRequest.phone = phone;
        offerRequest.email = email;
        offerRequest.address = address;
        offerRequest.zip = zip;
        offerRequest.city = city;
        offerRequest.province = province;
        offerRequest.buildingType = buildingType;
        offerRequest.buildingTypeOther = buildingTypeOther;
        offerRequest.area = area;
        offerRequest.constructionYear = constructionYear;
        offerRequest.additionalInfo = additionalInfo;
        offerRequest.serviceToken = "hankitiiveysmittaus";
  

        console.log(offerRequest);
        return offerRequest;
    }



    $("#sendFormBtn").on("click", function(event){
    
        if( $('#offerRequestForm')[0].checkValidity()){ 
            event.preventDefault();
            setSendBtnDisabled();

            let offerRequest = updateOfferRequest();
         //   offerRequest.recaptchaToken = token;
         //   offerRequest.recaptchaVersion = "v3";

            console.log("--- send offerRequest to server ----");
            console.log(JSON.stringify(offerRequest));
            console.log("server url " + Uris.jsonOfferRequestsAdd);

            $.ajax({
                url: Uris.jsonOfferRequestsAdd,
                method:"POST",
                data: JSON.stringify(offerRequest)
            })
            .done(function( data ) {
                console.log("success");
                console.log(data);
                
                setSendBtnActive();
                window.location.href = myLinks[language].thanks;
            })
            .fail(function(err){
                console.log("error");
                console.log(err);
                setSendBtnActive();
            });


        }
    });

    function clearForm(){
        $("#firstNameInput").val("");
        $("#lastNameInput").val("");
        $("#phoneInput").val("");
        $("#emailInput").val("");

        $("#addressInput").val("");
        $("#zipInput").val("");
        $("#cityInput").val("");
        $("#buildingTypeOtherInput").val("");
        $("#constructionYearInput").val("");
        $("#additionalInfoInput").val("");

        $('#provinceSelect').val("");
        $('#buildingTypeSelect').val("");
    }

    
    console.log(Uris.jsonServiceProvidersAdd);


    $('#firstNameInput').on('input',function(e){ updateOfferRequest(); });
    $('#lastNameInput').on('input',function(e){ updateOfferRequest(); });
    $('#phoneInput').on('input',function(e){ updateOfferRequest(); });
    $('#emailInput').on('input',function(e){ updateOfferRequest(); });
    $('#addressInput').on('input',function(e){ updateOfferRequest(); });
    $('#zipInput').on('input',function(e){ updateOfferRequest(); });
    $('#cityInput').on('input',function(e){ updateOfferRequest(); });
    $('#buildingTypeOtherInput').on('input',function(e){ updateOfferRequest(); });
    $('#constructionYearInput').on('input',function(e){ updateOfferRequest(); });
    $('#additionalInfoInput').on('input',function(e){ updateOfferRequest(); });
 


    $('#provinceSelect').on('change', function() {
        updateOfferRequest();
    });

    $('#buildingTypeSelect').on('change', function() {
        var buildingType = $(this).val();
        switch (buildingType) {
            case 'other':
                console.log('other');
                $("#buildingTypeOtherContainer").show();
                break;
            default:
                $("#buildingTypeOtherContainer").hide();
              
        }
        updateOfferRequest();
        // Check input( $( this ).val() ) for validity here
    });


   
    function setSendBtnDisabled(){
        $("#sendFormBtn").prop("disabled",true);
        $('#sendFormBtnLoadingText').show();
        $('#sendFormBtnDefaultText').hide();
    }

    function setSendBtnActive(){
        $("#sendFormBtn").prop("disabled",false);
        $('#sendFormBtnLoadingText').hide();
        $('#sendFormBtnDefaultText').show();
    }
    

});